import React from 'react'
import Picker from '../common/Picker'
import { translateProductType } from '../../utils/translator'

const ProductTypePicker = (props) => {

    const option = (type) => <span>{translateProductType(type)}</span>

    return (
        <Picker
            {...props}
            option={option}
        />
    )
}

export default ProductTypePicker